import React from 'react';
import PrivateRoute from './PrivateRoute';
import { getPathApp } from '../utils/util';
import { PERMISSIONS } from '../utils/constants';
import Home from '../containers/LoadUnload/Home/LoadUnloadHome';
import LoadUnload from '../containers/LoadUnload/LoadUnload';
import ShedConfig from '../containers/LoadUnload/ShedConfig';
import ListLogs from '../containers/LoadUnload/Log/LogList';
import LogListDetail from '../containers/LoadUnload/Log/LogListDetail';
import LoadUnloadParameters from "../containers/LoadUnload/LoadUnloadParameters";

let aux = 0;
const pathurl = getPathApp(window);
const LoadUnloadRoute = [
    <PrivateRoute key={aux += 1} path={`${pathurl}/loadunload/parametersConfirmation`} component={LoadUnloadParameters} validatePermission={PERMISSIONS.LoadUnload.Access} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/loadunload/logs/logdetails`} component={LogListDetail} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/loadunload/logs`} component={ListLogs} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/loadunload/home`} component={Home} validatePermission={PERMISSIONS.LoadUnload.Access} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/loadunload/loadunload`} component={LoadUnload} validatePermission={PERMISSIONS.LoadUnload.Access} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/loadunload/shedconfig`} component={ShedConfig} validatePermission={PERMISSIONS.LoadUnload.Config} />
];

export default LoadUnloadRoute;
